import React, { useEffect, useState } from "react";
import {
  Radio,
  FormControlLabel,
  Divider,
  useTheme,
  useMediaQuery,
  FormControl,
  Select,
  MenuItem,
  Stack,
  Box,
} from "@mui/material";
import BackgroundContainer from "./common/BackgroundContainer";
import PJM from "./PJM";
import MISO from "./MISO";
import ERCOT from "./ERCOT";
// import GradientButton from './commons/GradientButton';

/**
 * This component is for selecting the ISO using Radio buttons and then pass the selected ISO to the MarketOverview Component.
 */

const TABSelect = ({ iso }) => {
  // console.log("received iso: ", iso);

  let TabList = ["PJM", "MISO", "ERCOT"];

  const [SelectedISO, setSelectedISO] = useState(iso);

  // States
  const [tab, setTab] = useState(iso);

  // Handlers
  const handleTabChange = (newTab) => {
    setTab(newTab);
  };
  const [selectedValue, setSelectedValue] = useState(TabList.indexOf(iso));

  if (!TabList.includes(SelectedISO)) {
    setSelectedISO("MISO");
  }
  useEffect(() => {
    setTab(SelectedISO);
    setSelectedValue(TabList.indexOf(SelectedISO));
  }, [SelectedISO]);

  const handleRadioChange = (event) => {
    const index = event.target.value;
    setSelectedValue(Number(index));
    handleTabChange(TabList[index]);
  };
  const renderTemplate = () => {
    
    switch (tab) {
      case "PJM":
        return <PJM />
      case "MISO":
        return <MISO />
      case "ERCOT":
        return <ERCOT />
      default:
        return <></>;
    }
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if the screen size is mobile (sm and down)

  return (
    <>
      <BackgroundContainer
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          paddingX: 2,
          paddingY: 0.5,
          position: { sm: "sticky" },
          top: { sm: 40 },
          zIndex: 100,
          opacity: 1,
        }}
        direction="row"
      >
        {isMobile ? (
          <FormControl
            sx={{
              minWidth: 120,
              fontSize: "12px",
            }}
            fullWidth
          >
            <Select
              labelId="tab-select-label"
              id="tab-select"
              value={selectedValue}
              onChange={handleRadioChange} // assumes this function handles event.target.value
            >
              {TabList.map((tab, index) => (
                <MenuItem key={index} value={index}>
                  {tab}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          // Radio buttons for non-mobile screens
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1, 
              mx: "auto", 
              maxWidth: 400,
            }}
          >
            {[...Array(TabList.length)].map((_, index) => (
              <React.Fragment key={index}>
                <FormControlLabel
                  control={
                    <Radio
                      name="tab-selection"
                      value={index}
                      onChange={handleRadioChange}
                      checked={selectedValue === index}
                      sx={{ mr: 0.25 }} // Right margin for each radio button
                    />
                  }
                  label={TabList[index]}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "1rem",
                    mb: { xs: 1, sm: 0 },
                  }}
                />
                {index !== TabList.length - 1 && (
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ borderWidth: "0.5px" }}
                  />
                )}
              </React.Fragment>
            ))}
          </Box>
        )}
      </BackgroundContainer>

      {renderTemplate()}
    </>
  );
};

export default TABSelect;
